import React from "react";
import { Outlet } from "react-router-dom";
import PublicRoute from "./publicRoute";
import ROUTE_NAMES from "../routes/routeNames";

/**
 * @function AuthenticationRoutes
 * @description for Authentication i.e. Public Routes
 * @returns JS for AuthenticationRoutes
 */

//pages import
const Login = React.lazy(() => import("../views/auth/login"));
const Page404 = React.lazy(() => import("../views/page404"));
const ContactUs = React.lazy(() => import("../views/cms/contactUs"));
const Support = React.lazy(() => import("../views/cms/support"));
const TermAndConditions = React.lazy(
  () => import("../views/cms/termsAndCondition")
);
// const Faq = React.lazy(() => import("../views/cms/faq"));
const OpenFaq = React.lazy(() => import("../views/cms/faq/OpenFaq"));
const Wrapper = React.lazy(() => import("../components/cmsWrapper/CmsWrapper"));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: ROUTE_NAMES.BASE_ROUTE,
  element: <Outlet />,
  children: [
    {
      path: ROUTE_NAMES.BASE_ROUTE,
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: "*",
      element: (
        <PublicRoute>
          <Page404 />
        </PublicRoute>
      ),
    },
    {
      path: ROUTE_NAMES.PUBLIC_ROUTES.SUPPORT,
      element: (
        <PublicRoute>
          <Wrapper>
            <Support />
          </Wrapper>
        </PublicRoute>
      ),
    },
    {
      path: ROUTE_NAMES.PUBLIC_ROUTES.PRIVACY_POLICY,
      element: (
        <PublicRoute>
          <Wrapper>
            <Support />
          </Wrapper>
        </PublicRoute>
      ),
    },
    {
      path: ROUTE_NAMES.PUBLIC_ROUTES.CONTACT_US,
      element: (
        <PublicRoute>
          <Wrapper>
            <ContactUs />
          </Wrapper>
        </PublicRoute>
      ),
    },
    {
      path: ROUTE_NAMES.PUBLIC_ROUTES.TERM_AND_CONDITIONS,
      element: (
        <PublicRoute>
          <Wrapper>
            <TermAndConditions />
          </Wrapper>
        </PublicRoute>
      ),
    },
    // {
    //   path: ROUTE_NAMES.PUBLIC_ROUTES.FAQ,
    //   element: (
    //     <PublicRoute>
    //       <Wrapper>
    //         <Faq />
    //       </Wrapper>
    //     </PublicRoute>
    //   ),
    // },
    {
      path: ROUTE_NAMES.PUBLIC_ROUTES.FAQ,
      element: (
        <PublicRoute>
          <Wrapper>
            <OpenFaq />
          </Wrapper>
        </PublicRoute>
      ),
    },
  ],
};

export default AuthenticationRoutes;
